<template>
  <div class="container">
    <div class="stock-detail">
      <h1>
        <a :href="`https://stockpage.10jqka.com.cn/${stock.Code}`" target="_blank">{{ stock.Name }}</a> &nbsp;&nbsp;&nbsp;
        <a :href="`https://www.iwencai.com/unifiedwap/result?querytype=stock&w=${stock.Name}`" target="_blank">{{ stock.Code }}</a>
      </h1>
      <h4>{{ stock.Now }}</h4>
      <div class="stock-title">
        <span class="label">今日价格:{{ stock.CurPrice }}</span>
        <span class="label">涨跌幅:{{ stock.QuoteChange }}</span>
        <select id="date" v-model="selectedDate" @change="fetchStockData">
          <option v-for="time in stock.OnTimeList" :key="time" :value="time">{{ time }}</option>
        </select>
      </div>
      <div class="stock-info">
        <div class="info-item">
          <span class="label">流通市值:</span>
          <span class="value">{{ stock.Circulation }}亿</span>
        </div>
        <div class="info-item">
          <span class="label">换手率:</span>
          <span class="value">{{ stock.TurnoverRatio }}%</span>
        </div>
        <div class="info-item">
          <span class="label">今日净买入:</span>
          <span class="value" :style="{ color: getColor(stock.BuyIn) }">{{ (stock.BuyIn / 100000000).toFixed(2) }}亿</span>
        </div>
        <div class="info-item">
          <span class="label">关联营业部:</span>
          <span class="value">{{ stock.ToBusinessCount }}</span>
        </div>
      </div>

      <div v-if="isLoading">
        <p class="loading">加载中...</p>
      </div>
      <div v-else-if="error">
        <p class="error">{{ error }}</p>
      </div>
      <div v-else>
        <h3>
          上榜理由:{{ stock.List[0].UpReason[0] }}
        </h3>
        <div class="buy-sell-list" v-if="stock.List.length > 0">
          <h4>买入营业部</h4>
          <table>
            <thead>
              <tr>
                <th>排名</th>
                <th>名称</th>
                <th>买入金额(万)</th>
                <th>卖出金额(万)</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in stock.List[0].BuyList" :key="item.ID">
                <td>{{ index + 1 }}</td>
                <td>{{ item.Name }}</td>
                <td>{{ (item.Buy / 10000).toFixed(2) }}</td>
                <td>{{ (item.Sell / 10000).toFixed(2) }}</td>
              </tr>
            </tbody>
          </table>
          <div class="stat-item">
            <span class="label right_info">买入总计:{{ (stock.List[0].BuyTotal / 10000).toFixed(2) }} 万元</span>
          </div>
        </div>

        <div class="buy-sell-list" v-if="stock.List.length > 0">
          <h4>卖出营业部</h4>
          <table>
            <thead>
              <tr>
                <th>排名</th>
                <th>名称</th>
                <th>买入金额(万)</th>
                <th>卖出金额(万)</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in stock.List[0].SellList" :key="item.ID">
                <td>{{ index + 1 }}</td>
                <td>{{ item.Name }}</td>
                <td>{{ (item.Buy / 10000).toFixed(2) }}</td>
                <td>{{ (item.Sell / 10000).toFixed(2) }}</td>
              </tr>
            </tbody>
          </table>
          <div class="stat-item">
            <span class="label right_info">卖出总计:{{ (stock.List[0].SellTotal / 10000).toFixed(2) }} 万元</span>
          </div>
        </div>

        <div v-else>
          <p class="no-data">暂无数据</p>
        </div>
      </div>
    </div>

    <div class="iframe-container">
     <div class="iframe-wrapper" v-for="(url, index) in dynamicIframeUrls" :key="index">
      <iframe :src="url" width="100%" height="600px" frameborder="0"></iframe>
    </div>
    </div>
  </div>
   <!-- 使用组件 -->
    <MobileIframeViewer
      v-if="showIframe"
      :show-iframe="showIframe"
      :iframe-src="iframeSrc"
      @close="closeIframe"
    />
</template>

<script>
import axios from 'axios';
import MobileIframeViewer from '@/components/MobileIframeViewer.vue';
export default {
 components: {
    MobileIframeViewer
  },
  data() {
    return {
      stock: {
        List: [],
        OnTimeList: []
      },
      iframeSrc: '',
      showIframe: false,
      isLoading: true,
      selectedDate: '',
      stock_code: '',
      error: '',
      iframeUrls: []
    };
  },
  computed: {
      dynamicIframeUrls() {
        const code = this.stock_code;
        return [
            `https://m.10jqka.com.cn/stockpage/hs_${code}/#refCountId=R_56307738_256.html&atab=geguNews`,
            `https://gu.qq.com/${code}/gp/price`
        ];
      }
    },
  created() {
    this.stock_code = this.$route.query.stock_code || '';
    if (this.stock_code) {
      this.fetchStockData();
    } else {
      this.error = '股票代码未提供';
    }
  },
  watch: {
    selectedDate() {
      this.fetchStockData();
    }
  },
  methods: {
    async fetchStockData() {
      this.isLoading = true;
      this.error = '';
      try {
        console.log('获取股票数据', this.stock_code, this.selectedDate);

        const response = await axios.get(`/api/stock_detail?stock_code=${this.stock_code}&date=${this.selectedDate}`);
        console.log('获取股票数据成功', response.data);
        this.stock = response.data;
        // 如果 selectedDate 为空，设置默认选中的日期为最新的时间点
        if (!this.selectedDate && this.stock.OnTimeList && this.stock.OnTimeList.length > 0) {
          this.selectedDate = this.stock.OnTimeList[0];
        }
      } catch (error) {
        console.error('获取股票数据失败', error);
        this.error = '获取股票数据失败，请稍后再试';
      } finally {
        this.isLoading = false;
      }
    },
    getColor(value) {
      return value > 0 ? 'red' : 'green';
    }
  }
};
</script>

<style scoped>
.container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
}

.stock-detail {
  flex: 1;
  margin-right: 20px;
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  padding: 20px;
}

h1, h3, h4 {
  text-align: left;
  color: #333333;
  margin-bottom: 20px;
}

h1 {
  font-size: 24px;
}

h3 {
  font-size: 18px;
}

h4 {
  margin: 0;
  padding: 2px;
  font-size: 16px;
  color: #555555;
}

a {
  color: #333333;
  text-decoration: none;
}

.stock-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  background-color: #f9f9f9;
  padding: 10px;
  border-radius: 4px;
}

.stock-title .label, .info-item .label {
  font-weight: bold;
  color: #555555;
  margin-right: 10px;
}

.stock-title .value, .info-item .value {
  color: #333333;
  margin-right: 20px;
}

.stock-title select {
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
  transition: border-color 0.3s;
  background-color: #ffffff;
}

.stock-title select:focus {
  border-color: #007bff;
  outline: none;
}

.stock-info {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-bottom: 20px;
}

.info-item {
  flex: 1 1 45%;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  background-color: #f9f9f9;
  padding: 10px;
  border-radius: 4px;
  margin-right: 10px;
}

.info-item:last-child {
  margin-right: 0;
}

.buy-sell-list {
  margin-bottom: 20px;
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 10px;
}

.buy-sell-list h4 {
  margin-bottom: 10px;
  color: #333333;
}

.buy-sell-list table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 20px;
}

.buy-sell-list th, .buy-sell-list td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: left;
  transition: background-color 0.3s;
}

.buy-sell-list th {
  background-color: #f4f4f4;
  color: #555555;
}

.buy-sell-list tr:nth-child(even) {
  background-color: #f9f9f9;
}

.buy-sell-list tr:hover {
  background-color: #f1f1f1;
}

.stat-item {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  background-color: #f9f9f9;
  padding: 10px;
  border-radius: 4px;
}

.stat-item .label {
  font-weight: bold;
  color: #555555;
}

.right_info {
  text-align: right;
}

.stat-item .value {
  color: #333333;
}

.loading, .error, .no-data {
  text-align: center;
  font-size: 1.2em;
}

.loading {
  color: #555555;
}

.error {
  color: red;
}

.no-data {
  color: #555555;
}

.positive {
  color: #28a745; /* 绿色 */
}

.negative {
  color: #dc3545; /* 红色 */
}

.iframe-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  margin-bottom: 20px;
}

.iframe-wrapper {
  width: 100%;
  height: 600px;
  border: 1px solid #ddd;
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: 20px;
}

.iframe-wrapper iframe {
  width: 100%;
  height: 100%;
  border: none;
}

@media (max-width: 1200px) {
  .container {
    flex-direction: column;
  }

  .stock-detail {
    margin-right: 0;
    margin-bottom: 20px;
  }

  .iframe-container {
    margin-top: 0;
  }
}
</style>
